
var sprite = require("/opt/build/repo/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 11.54 14\" id=\"lock\" ><defs/><title>lock</title><g id=\"lock_Layer_2\" data-name=\"Layer 2\"><path class=\"cls-1\" d=\"M5.77 0a4.21 4.21 0 0 0-4.28 4.13V6H0v8h11.54V6h-1.48V4.13A4.21 4.21 0 0 0 5.77 0zm0 1.84a2.33 2.33 0 0 1 2.36 2.29V6H3.42V4.13a2.29 2.29 0 0 1 2.33-2.29z\" id=\"lock_Icons\"/></g></symbol>";
module.exports = sprite.add(image, "lock");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/lock.svg
// module id = 661
// module chunks = 1474